// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.container {
  height: 100vh;
  /* 부모 요소의 높이 설정 */
}

.content {
  width: calc(100% - 260px);
  float: left;
  max-height: calc(100% - 80px);
  overflow: auto;
  position: relative;
}

.mr10 {
  margin-right: 1rem !important;
}

.sub_top {
  width: 100%;
  height: 80px;
  padding: 0 20px;
  display: flex;
  border-bottom: 1px solid #ebebeb;
  align-items: center;
}
.sub_top .main_back {
  font-size: 2rem;
  font-family: "S-Core";
}
.sub_top .main_back .icofont-arrow-lef::before {
  content: "\\ea5c";
}

.sub_menu_wrap {
  width: 260px;
  position: relative;
  height: calc(100% - 80px);
  float: left;
  padding: 30px;
  display: flex;
  justify-content: center;
}
.sub_menu_wrap .sub_menu {
  width: 100%;
}
.sub_menu_wrap .sub_menu li {
  width: 100%;
  padding: 10px 20px;
  border-radius: 50px;
}
.sub_menu_wrap .sub_menu li button {
  font-size: 1.6rem;
  width: 100%;
  height: 100%;
  text-align: left;
  font-family: "S-Core";
}
.sub_menu_wrap .sub_menu li ~ li {
  margin-top: 20px;
}
.sub_menu_wrap .logo {
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 75px;
  justify-content: center;
  position: absolute;
  bottom: 0;
  margin-bottom: 40px;
}
.sub_menu_wrap .logo button {
  width: 120px;
}
.sub_menu_wrap .logo button img {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Menu/css/menu.css","webpack://./src/components/Menu/css/menu.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EAEE,aAAA;EACA,iBAAA;ADCF;;ACEA;EACE,yBAAA;EACA,WAAA;EACA,6BAAA;EACA,cAAA;EAEA,kBAAA;ADAF;;ACGA;EACE,6BAAA;ADAF;;ACIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;EACA,mBAAA;ADDF;ACGE;EACE,eAAA;EACA,qBAAA;ADDJ;ACGI;EACE,gBAAA;ADDN;;ACOA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;ADJF;ACME;EACE,WAAA;ADJJ;ACMI;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;ADJN;ACMM;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;ADJR;ACQI;EACE,gBAAA;ADNN;ACUE;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;ADRJ;ACUI;EACE,YAAA;ADRN;ACUM;EACE,WAAA;ADRR","sourcesContent":["@charset \"UTF-8\";\n.container {\n  height: 100vh;\n  /* 부모 요소의 높이 설정 */\n}\n\n.content {\n  width: calc(100% - 260px);\n  float: left;\n  max-height: calc(100% - 80px);\n  overflow: auto;\n  position: relative;\n}\n\n.mr10 {\n  margin-right: 1rem !important;\n}\n\n.sub_top {\n  width: 100%;\n  height: 80px;\n  padding: 0 20px;\n  display: flex;\n  border-bottom: 1px solid #ebebeb;\n  align-items: center;\n}\n.sub_top .main_back {\n  font-size: 2rem;\n  font-family: \"S-Core\";\n}\n.sub_top .main_back .icofont-arrow-lef::before {\n  content: \"\\ea5c\";\n}\n\n.sub_menu_wrap {\n  width: 260px;\n  position: relative;\n  height: calc(100% - 80px);\n  float: left;\n  padding: 30px;\n  display: flex;\n  justify-content: center;\n}\n.sub_menu_wrap .sub_menu {\n  width: 100%;\n}\n.sub_menu_wrap .sub_menu li {\n  width: 100%;\n  padding: 10px 20px;\n  border-radius: 50px;\n}\n.sub_menu_wrap .sub_menu li button {\n  font-size: 1.6rem;\n  width: 100%;\n  height: 100%;\n  text-align: left;\n  font-family: \"S-Core\";\n}\n.sub_menu_wrap .sub_menu li ~ li {\n  margin-top: 20px;\n}\n.sub_menu_wrap .logo {\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  height: 75px;\n  justify-content: center;\n  position: absolute;\n  bottom: 0;\n  margin-bottom: 40px;\n}\n.sub_menu_wrap .logo button {\n  width: 120px;\n}\n.sub_menu_wrap .logo button img {\n  width: 100%;\n}/*# sourceMappingURL=menu.css.map */",".container {\r\n\r\n  height: 100vh;\r\n  /* 부모 요소의 높이 설정 */\r\n}\r\n\r\n.content {\r\n  width: calc(100% - 260px);\r\n  float: left;\r\n  max-height: calc(100% - 80px);\r\n  overflow: auto;\r\n  // padding: 40px;\r\n  position: relative;\r\n}\r\n\r\n.mr10 {\r\n  margin-right: 1rem !important;\r\n}\r\n\r\n// header\r\n.sub_top {\r\n  width: 100%;\r\n  height: 80px;\r\n  padding: 0 20px;\r\n  display: flex;\r\n  border-bottom: 1px solid #ebebeb;\r\n  align-items: center;\r\n\r\n  .main_back {\r\n    font-size: 2rem;\r\n    font-family: 'S-Core';\r\n\r\n    .icofont-arrow-lef::before {\r\n      content: \"\\ea5c\";\r\n    }\r\n  }\r\n}\r\n\r\n// left menu\r\n.sub_menu_wrap {\r\n  width: 260px;\r\n  position: relative;\r\n  height: calc(100% - 80px);\r\n  float: left;\r\n  padding: 30px;\r\n  display: flex;\r\n  justify-content: center;\r\n\r\n  .sub_menu {\r\n    width: 100%;\r\n\r\n    li {\r\n      width: 100%;\r\n      padding: 10px 20px;\r\n      border-radius: 50px;\r\n\r\n      button {\r\n        font-size: 1.6rem;\r\n        width: 100%;\r\n        height: 100%;\r\n        text-align: left;\r\n        font-family: 'S-Core';\r\n      }\r\n    }\r\n\r\n    li~li {\r\n      margin-top: 20px;\r\n    }\r\n  }\r\n\r\n  .logo {\r\n    width: 100%;\r\n    margin: 0 auto;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 75px;\r\n    justify-content: center;\r\n    position: absolute;\r\n    bottom: 0;\r\n    margin-bottom: 40px;\r\n\r\n    button {\r\n      width: 120px;\r\n\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
